<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <valuations-grid [hidden]="!showGrid" [workspace]="this"></valuations-grid>
  </div>
</div>
